export default __webpack_public_path__ + "static/media/card-next.d4b089ef.svg";